import * as React from "react";

const Aside = (props: {children?: React.ReactNode}) => (
    <aside className="ll-aside">
        {props.children}
    </aside>
);

export default Aside;